export default {"src":"/newStatic/_next/static/media/boxes.9d66fc62.svg","height":55,"width":71};